import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { fmtBRL, fmtDate } from "@/lib/medicoes";

const COLS = [
  ["numero", "Contrato"], [null, "Órgão"], [null, "Objeto"], [null, "Processo"], ["data_inicio", "Vigência"],
  [null, "Valor inicial"], [null, "Aditivos/reajustes"], ["valor", "Atualizado"], [null, "Medido"], [null, "Aprovado"],
  [null, "Pago"], ["saldo", "Saldo"], ["pct", "% exec."], [null, "Situação"],
];

export default function FornecedorContratos() {
  const [q, setQ] = useState({ search: "", status: "", sort: "data_fim", order: "desc" });
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    const params = Object.fromEntries(Object.entries(q).filter(([, v]) => v));
    const t = setTimeout(() => api.get("/fornecedor/contratos", { params }).then((r) => setData(r.data)).finally(() => setLoading(false)), 250);
    return () => clearTimeout(t);
  }, [q]);
  const sortBy = (k) => k && setQ((s) => ({ ...s, sort: k, order: s.sort === k && s.order === "desc" ? "asc" : "desc" }));
  return (
    <div className="space-y-6" data-testid="fornecedor-contratos">
      <div>
        <div className="uppercase-label">Área do Fornecedor</div>
        <h1 className="font-heading text-4xl tracking-tight mt-2">Meus contratos</h1>
        <p className="text-sm text-[#94A3B8] mt-2">{data.total} contrato(s) vinculado(s)</p>
      </div>
      <div className="tce-card p-4 flex flex-wrap gap-3">
        <div className="relative flex-1 min-w-[220px]">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
          <input data-testid="fc-search" value={q.search} onChange={(e) => setQ({ ...q, search: e.target.value })}
                 placeholder="Número, objeto, órgão, município…" className="tce-input w-full pl-10 pr-3 py-2.5 rounded-md text-sm" />
        </div>
        <select data-testid="fc-status" value={q.status} onChange={(e) => setQ({ ...q, status: e.target.value })} className="tce-input px-3 py-2.5 rounded-md text-sm">
          <option value="">Todas as situações</option>
          {["ativo", "encerrado", "vencido", "suspenso"].map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div className="tce-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="bg-[#1E293B] text-left">
              <tr>{COLS.map(([k, l]) => (
                <th key={l} onClick={() => sortBy(k)} className={`px-3 py-3 uppercase-label !text-[10px] whitespace-nowrap ${k ? "cursor-pointer hover:text-[#FFDF00]" : ""}`}>
                  {l}{q.sort === k ? (q.order === "desc" ? " ↓" : " ↑") : ""}
                </th>))}
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={14} className="px-4 py-8 text-center text-[#94A3B8]">Carregando…</td></tr>}
              {!loading && !data.items.length && <tr><td colSpan={14} className="px-4 py-8 text-center text-[#94A3B8]">Nenhum contrato encontrado.</td></tr>}
              {!loading && data.items.map((c, i) => (
                <tr key={c.id} className="border-t border-[#334155] hover:bg-[#1E293B]/60" data-testid={`fc-row-${i}`}>
                  <td className="px-3 py-3"><Link to={`/fornecedor/contratos/${c.id}`} className="font-mono text-[#FFDF00] hover:underline" data-testid={`fc-link-${i}`}>{c.numero}</Link></td>
                  <td className="px-3 py-3 text-[#94A3B8] min-w-[140px]">{c.orgao || "—"}<div className="text-[10px]">{c.municipio_nome}</div></td>
                  <td className="px-3 py-3 max-w-[240px] truncate" title={c.objeto}>{c.objeto}</td>
                  <td className="px-3 py-3 text-[#94A3B8]">{c.numero_processo || c.processo || "—"}</td>
                  <td className="px-3 py-3 whitespace-nowrap text-[#94A3B8]">{fmtDate(c.data_inicio)} → {fmtDate(c.data_fim)}</td>
                  <td className="px-3 py-3 font-mono text-right">{fmtBRL(c.resumo.valor_inicial)}</td>
                  <td className="px-3 py-3 font-mono text-right">{fmtBRL(c.resumo.valor_aditivos)}</td>
                  <td className="px-3 py-3 font-mono text-right text-[#FFDF00]">{fmtBRL(c.resumo.valor_atualizado)}</td>
                  <td className="px-3 py-3 font-mono text-right">{fmtBRL(c.resumo.valor_medido)}</td>
                  <td className="px-3 py-3 font-mono text-right">{fmtBRL(c.resumo.valor_aprovado)}</td>
                  <td className="px-3 py-3 font-mono text-right">{fmtBRL(c.resumo.valor_pago)}</td>
                  <td className="px-3 py-3 font-mono text-right text-[#22C55E]">{fmtBRL(c.resumo.saldo_contratual)}</td>
                  <td className="px-3 py-3 font-mono text-right">{c.resumo.pct_execucao.toFixed(1)}%</td>
                  <td className="px-3 py-3">{c.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
